import { useSearchParams } from 'react-router';
import { IFilterItem } from '../data-types/filterItem';

export const useSelectedEntities = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedEntities = searchParams.get('selectedEntities') ? (searchParams.get('selectedEntities') || '').split(',') : [];

    const setSelectedEntitiesSearchParams = (filteredItems: IFilterItem[]) => {
        const filteredItemsKey = filteredItems.map((i) => i.key).join(',');
        const currentSelectedEntitiesParam = searchParams.get('selectedEntities') ?? '';
        if (filteredItemsKey === currentSelectedEntitiesParam) {
            return;
        }
        setSearchParams(
            (prev) => {
                const next = new URLSearchParams(prev);
                if (filteredItemsKey) {
                    next.set('selectedEntities', filteredItemsKey);
                } else {
                    next.delete('selectedEntities');
                }
                return next;
            },
            { replace: true }
        );
    };

    const getFilteredEntities = (entities: IFilterItem[]): IFilterItem[] =>
        entities.filter((e) => selectedEntities.some((p) => p === e.key));

    return { selectedEntities, setSearchParams, setSelectedEntitiesSearchParams, getFilteredEntities, searchParams };
};
